import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { PUR1030_R01DetailDto } from "../Dto_PUR1030_R01";

interface UsePUR1030_R01CellChangeProps {
	PUR1030_R01DetailList: PUR1030_R01DetailDto[];
	originalPUR1030_R01DetailList: PUR1030_R01DetailDto[];
	updatePUR1030_R01DetailList: (index: number, data: PUR1030_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<PUR1030_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
}

export function usePUR1030_R01CellChange({
	PUR1030_R01DetailList,
	originalPUR1030_R01DetailList,
	updatePUR1030_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
}: UsePUR1030_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const PUR1030R01Config = createModuleConfig.PUR1030();

	const fieldConfigWithSearch = {
		...PUR1030R01Config.fieldConfig,
		codeSearchFields: {
			...PUR1030R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...PUR1030R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFunction: searchExactItemCode,
				canOpenModal: (row: PUR1030_R01DetailDto) => !!row?.inserted,
			},
		},
	};

	const PUR1030_FIELD_MAPPING = {
		qtyField: "orderQty",
		priceField: "orderPrice",
		dcField: "dcAmt",
		amountField: "itemAmt",
		preventNegative: true,
	};

	return useCommonDetailTableHandlers<PUR1030_R01DetailDto>({
		detailList: PUR1030_R01DetailList,
		updateDetailList: updatePUR1030_R01DetailList,
		originalDetailList: originalPUR1030_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: PUR1030R01Config.codeSearchConfig,
		calculateAmount: (data: PUR1030_R01DetailDto) =>
			calculateDetailAmount(data, PUR1030_FIELD_MAPPING),
	});
}
